// extracted by mini-css-extract-plugin
module.exports = {"button":"StickyToggle_button__29V1n","wrapper":"StickyToggle_wrapper__2zrSm"};